import { HeaderComponent } from './components/HeaderComponent';
import { MenuComponent } from './components/MenuComponent';
import { PortalComponent } from './components/PortalComponent';
import { CarouselComponent } from './components/CarouselComponent';
import { LightGalleryComponent } from './components/LightGalleryComponent';
import { DynamicGalleryComponent } from './components/DynamicGalleryComponent';
import { AccordeonComponent } from './components/AccordeonCompnonent';
import { GalleryComponent } from './components/GalleryComponent';
import { AnchorScrollComponent } from './components/AnchorScrollComponent';
import { Fixer } from './components/Fixer';
import { InfoButton } from './components/InfoButton';
import { AutomaticIdentification } from './components/AutomaticIdentification';
(new HeaderComponent()).init();
(new MenuComponent()).init();
(new CarouselComponent()).init();
(new LightGalleryComponent()).init();
(new DynamicGalleryComponent()).init();
(new AccordeonComponent()).init();
(new GalleryComponent()).init();
(new AnchorScrollComponent()).init();
(new PortalComponent()).init();
(new Fixer()).init();
(new InfoButton).init();
(new AutomaticIdentification()).init();
